import HadithRulings from './HadithRulings';

export { HadithRulings };
